// App.jsx

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from './auth/authContext';
import AppRoutes from './routes/AppRoutes';
import { AccountClosureProvider } from './features/account-lifecycle/AccountClosureProvider';
import { FacilitatorCapabilityProvider } from './features/facilitated-surfaces/context/FacilitatorCapabilityContext';
import {
  defaultAppLanguage,
  LanguageProvider,
  supportedAppLanguages
} from './locales/LanguageContext';
import './styles/app.css';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const normalizedLanguage = supportedAppLanguages.includes(i18n.language)
      ? i18n.language
      : defaultAppLanguage;

    if (i18n.language !== normalizedLanguage) {
      i18n.changeLanguage(normalizedLanguage);
    }
  }, [i18n, i18n.language]);

  return (
    <AuthProvider>
      <AccountClosureProvider>
      <FacilitatorCapabilityProvider>
        <LanguageProvider>
          <div className="ltr">
            <AppRoutes />
          </div>
        </LanguageProvider>
      </FacilitatorCapabilityProvider>
      </AccountClosureProvider>
    </AuthProvider>
  );
}

export default App;
